import React, { useState } from 'react'
import ProfileTab from '../../components/profileTabs/ProfileTab';
import '../profile/Profile.css'
import AccountTab from '../../components/accountTabs/AccountTab';
import WalletTab from '../../components/walletTabs/WalletTab';
import BlockedTab from '../../components/blockedTabs/BlockedTab';
import ReportTabs from '../../components/reportTabs/ReportTabs';
import SubscriptionTab from '../../components/subscriptionTabs/SubscriptionTab';

const Profile = () => {
  const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
  return (
    
    <div className='dashboard-content-box dashboard-profile-content-box'>
    <div className="tabs-container profile-sec">
      <div className='innerProfile-sec d-flex flex-wrap'>
        <div className="tabs-header sticky-md-top ">
          <button className={`tab-button ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}> Profile </button>
          <button className={`tab-button ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}> Account </button>
          <button className={`tab-button ${activeTab === 2 ? "active" : ""}`} onClick={() =>  setActiveTab(2)}> Wallet </button>
          <button className={`tab-button ${activeTab === 3 ? "active" : ""}`} onClick={() =>  setActiveTab(3)}> Blocked </button>
          {/* <button className={`tab-button ${activeTab === 4 ? "active" : ""}`} onClick={() =>  setActiveTab(4)}> Report </button> */}
          <button className={`tab-button ${activeTab === 5 ? "active" : ""}`} onClick={() =>  setActiveTab(5)}> Subscription </button>
        </div>

        <div className="tabs-content profileTabsSec">
          {activeTab === 0 && (
              <div className="tab-panel">
                 <ProfileTab />
              </div>
          )}
          {activeTab === 1 && (
              <div className="tab-panel">
                <AccountTab />
              </div>
          )}
          {activeTab === 2 && (
              <div className="tab-panel">
                <WalletTab />
              </div>
          )}
          {activeTab === 3 && (
              <div className="tab-panel">
                <BlockedTab />
              </div>
          )}
          {activeTab === 4 && (
              <div className="tab-panel">
                <ReportTabs />
              </div>
          )}
          {activeTab === 5 && (
              <div className="tab-panel">
                <SubscriptionTab />
              </div>
          )}
        </div>
      </div>
    </div>
  </div>
  )
}

export default Profile
